import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { CommonModule } from '@angular/common';
import { CloseOnOutsideDirective } from '@awread/global/packages';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  standalone: true,
  selector: 'atom-select-tags',
  imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule, CloseOnOutsideDirective],
  templateUrl: './select-tags.atom.html',
  styles: [
    `
      :host {
        display: block;
      }

      .custom-checkbox {
        display: block;
        position: relative;
        padding-left: 1.5rem;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
      }

      .custom-checkbox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
      }

      .checkmark {
        position: absolute;
        top: 3.5px;
        left: 0;
        height: 1rem;
        width: 1rem;
        background-color: white;
        border: 1px solid #804028;
        border-radius: 0.2rem;
      }

      .custom-checkbox input:checked ~ .checkmark {
        background-color: #804028;
      }

      .checkmark:after {
        content: '';
        position: absolute;
        display: none;
      }

      .custom-checkbox input:checked ~ .checkmark:after {
        display: block;
      }

      .custom-checkbox .checkmark:after {
        left: 5px;
        top: 1px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectTagsAtom implements OnInit {
  faIcon = faPlus;
  @Input() tag: any;
  @Input() currentTags: any;
  @Input() tags: any;
  @Output() eventTag = new EventEmitter();
  @Input() inputControl = new FormControl();
  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {}

  focusInput() {
    document.getElementById('fieldTag')?.focus();
  }

  closeAutoComplete() {
    this.tags = [];
    this.tag.newNameTag = '';
  }
}
